/* =========================================================
   PAS · "More to Explore" block (snippets/more-to-explore.liquid)

   Defined as a custom element rather than an inline <script> in the
   snippet: if the block is ever injected by JavaScript (a rendered
   section, a quick view) an inline script would not run, whereas a
   custom element upgrades the moment the markup lands in the DOM.

   Two jobs:
     1. the desktop "Load more" button
     2. the progress bar under the mobile swipe row
   ========================================================= */
(function () {
  if (customElements.get('pas-mte')) return;

  class PasMte extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pasReady === '1') return;
      this.dataset.pasReady = '1';

      this.grid = this.querySelector('.pas-mte__grid');
      this.track = this.querySelector('[data-pas-mte-progress]');
      this.thumb = this.querySelector('[data-pas-mte-thumb]');
      this.moreBtn = this.querySelector('[data-pas-mte-more]');

      this.onPaint = this.paint.bind(this);
      this.onExpand = this.expand.bind(this);

      if (this.moreBtn) this.moreBtn.addEventListener('click', this.onExpand);

      if (this.grid) {
        /* passive: this must never get in the way of the swipe itself */
        this.grid.addEventListener('scroll', this.onPaint, { passive: true });
        window.addEventListener('resize', this.onPaint);
        window.addEventListener('load', this.onPaint);
        window.addEventListener('orientationchange', this.onPaint);

        /* the row can change width without the window changing size —
           a sticky panel opening, a grid reflow, images landing */
        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(this.onPaint);
          this.ro.observe(this.grid);
        }

        /* images change the width of the row as they arrive, so remeasure */
        var imgs = this.grid.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          if (!imgs[i].complete) imgs[i].addEventListener('load', this.onPaint);
        }

        var el = this;
        requestAnimationFrame(function () {
          el.paint();
        });
      }
    }

    disconnectedCallback() {
      if (this.moreBtn) this.moreBtn.removeEventListener('click', this.onExpand);
      if (this.ro) this.ro.disconnect();
      if (!this.grid) return;
      this.grid.removeEventListener('scroll', this.onPaint);
      window.removeEventListener('resize', this.onPaint);
      window.removeEventListener('load', this.onPaint);
      window.removeEventListener('orientationchange', this.onPaint);
    }

    expand() {
      var hidden = this.querySelectorAll('.pas-mte__item.is-hidden');
      for (var i = 0; i < hidden.length; i++) hidden[i].classList.remove('is-hidden');
      if (this.moreBtn) this.moreBtn.setAttribute('aria-expanded', 'true');
      this.classList.add('is-expanded');
      this.paint();
    }

    paint() {
      var g = this.grid;
      var track = this.track;
      var thumb = this.thumb;
      if (!g || !track || !thumb) return;

      var overflow = g.scrollWidth - g.clientWidth;

      /* not a carousel (desktop grid, or everything already fits) */
      if (overflow < 8) {
        track.hidden = true;
        return;
      }
      track.hidden = false;

      var visiblePct = Math.min(100, (g.clientWidth / g.scrollWidth) * 100);
      var leftPct = (g.scrollLeft / g.scrollWidth) * 100;

      thumb.style.width = visiblePct.toFixed(2) + '%';
      thumb.style.left = leftPct.toFixed(2) + '%';
      this.classList.toggle('is-swiped', g.scrollLeft > 4);
    }
  }

  customElements.define('pas-mte', PasMte);
})();
